const svgLoading = "https://firebasestorage.googleapis.com/v0/b/templedekhodev.appspot.com/o/addmodal%2Floader_image_.gif?alt=media&token=23d39387-cd39-4ebe-8bfa-27c9352e9c4a"


export {
    svgLoading,
}